'use client';

import Image from 'next/image';

import { trackAnalyticsEvent } from '@/app/lib/analytics';

type MobileBadgeProps = {
  href?: string;
  src: string;
  alt: string;
  width: number;
  height: number;
  testid: string;
  analyticEventName?: string;
};

export const MobileBadge = ({
  href,
  src,
  alt,
  width,
  height,
  testid,
  analyticEventName,
}: MobileBadgeProps) => {
  return (
    <a
      href={href}
      onClick={() => {
        if (analyticEventName) {
          trackAnalyticsEvent(analyticEventName);
        }
      }}
    >
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        data-testid={testid}
      />
    </a>
  );
};
